import { ElNotification } from 'element-plus'
import {Storage} from '@/utils/storage'


export function showNotify(messageNumber, item, fun) {
    if (item) {
        const {msg_front_from, msgTxt, msg_front_subject} = item
        console.log(item, 'item')
        const replaceEmail = msg_front_from.replace(/^<|>$/g, "")
        ElNotification({
            position: 'bottom-right',
            duration: 2500,
            dangerouslyUseHTMLString: true,
            onClick() {
                fun()
            },
            message: `<div class="notify_box">
            <div class="notify_left">
                <div class="notify_inner" style="background-color:#5272e5;padding: 0px 14px;border-radius: 8px">
                    <svg t="1708593116687" className="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="5124" width="32" height="32">
                        <path
                            d="M891.904 145.92H128.512c-55.808 0-101.376 45.568-101.376 101.376v573.952c0 55.808 45.568 101.376 101.376 101.376h763.392c55.808 0 101.376-45.568 101.376-101.376V247.296c0-55.808-45.568-101.376-101.376-101.376z m-10.24 68.096l-352.768 285.184c-1.024 0.512-2.048 1.536-2.56 2.56-8.704 8.704-23.04 8.704-31.744 0l-2.56-2.56-352.768-285.184h742.4z m10.24 640.512H128.512c-18.432 0-32.768-14.848-32.768-32.768V266.752l351.744 284.672c17.408 16.896 39.936 25.088 62.464 25.088 22.528 0 45.056-8.192 62.464-25.088l351.744-284.672v554.496c0.512 18.432-13.824 33.28-32.256 33.28z"
                            p-id="5125" fill="#fff"></path>
                    </svg>
                </div>
                <div class="badge">
                    ${messageNumber}
                </div>
            </div>
            <div class="notify_right" style="width: 200px;">
                <div>
                    <span class="userInfo notification" style="display:inline-block;width:100%;margin-left:-10px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;line-height: 0px;background: white;height: 20px;">
                        ${replaceEmail}
                    </span>
                </div>
          <div 
            style="width: 185px; /* 设置容器的宽度 */
            height: auto; /* 自动高度，以适应内容 */
            overflow: hidden; /* 隐藏溢出的内容 */
            box-sizing: border-box; /* 包括内边距和边框在内的宽度计算 */
            word-wrap: break-word; /* 允许单词换行 */
            white-space: normal; /* 允许换行 */
            text-overflow: ellipsis; /* 超出内容显示省略号 */
            display: -webkit-box; /* 使用 webkit 弹性盒子布局 */
            -webkit-line-clamp: 2; /* 设置显示的行数（2行） */
            -webkit-box-orient: vertical; /* 垂直排列 */  
        }">
                    ${msg_front_subject}...
                </div>
            </div>
        </div>`
        })
    }
}

export function showWhatsAppNotify(messageNumber, payload, fun) {
    if (!payload) return
    try {
    const WA_LOGIN_STORAGE_KEY = 'wa_login_user'
    const isWhatsAppLogin = () => {
        try {
            const user = Storage.get(WA_LOGIN_STORAGE_KEY)
            return !!(user && user.id && (user.name || user.pushName))
        } catch (e) {
            return false
        }
    }

    if (!isWhatsAppLogin()) return

    const stripWaIdSuffix = (v) => {
        const s = String(v || '').trim()
        if (!s) return ''
        return s.replace(/@.*$/, '')
    }

    const WA_JID_MAP_STORAGE_KEY = 'wa_jid_map'
    const getJidMap = () => {
        try {
            const cached = Storage.get(WA_JID_MAP_STORAGE_KEY)
            const lidToPn = cached?.lidToPn && typeof cached.lidToPn === 'object' ? cached.lidToPn : {}
            const pnToLid = cached?.pnToLid && typeof cached.pnToLid === 'object' ? cached.pnToLid : {}
            return { lidToPn, pnToLid }
        } catch (e) {
            return { lidToPn: {}, pnToLid: {} }
        }
    }

    const buildComparableChatIds = (jid) => {
        const raw = String(jid || '').trim()
        if (!raw) return []

        const map = getJidMap()
        const ids = new Set()
        const push = (v) => {
            const s = String(v || '').trim()
            if (!s) return
            ids.add(s)
            const stripped = stripWaIdSuffix(s)
            if (stripped) ids.add(stripped)
        }

        push(raw)

        // lid <-> pn
        if (raw.endsWith('@lid')) {
            const pn = map?.lidToPn?.[raw]
            if (pn) push(pn)
        }
        if (raw.endsWith('@c.us')) {
            const lid = map?.pnToLid?.[raw]
            if (lid) push(lid)
        }

        // suffix-agnostic fallbacks
        const base = stripWaIdSuffix(raw)
        if (base) {
            push(`${base}@c.us`)
            push(`${base}@lid`)
        }

        return Array.from(ids)
    }

    const chatId = String(payload.chatId || '')
    const chatIdDisplay = stripWaIdSuffix(chatId)
    const userName = String(payload?.userName || '').trim()
    const titleDisplay = userName || chatIdDisplay
    const rawMessage = String(
        payload && payload.message != null
            ? payload.message
            : payload && payload.content != null
                ? payload.content
                : payload && payload.text != null
                    ? payload.text
                    : ''
    )

    const pickDefaultAttachmentText = () => {
        const files = Array.isArray(payload?.files)
            ? payload.files
            : Array.isArray(payload?.attachments)
                ? payload.attachments
                : Array.isArray(payload?.media)
                    ? payload.media
                    : []

        const first =
            (files && files.length ? files[0] : null) ||
            payload?.file ||
            payload?.attachment ||
            payload?.media ||
            null

        if (!first && (!files || !files.length)) return ''

        const mime = String(
            first?.mimetype ||
            first?.mimeType ||
            payload?.mimetype ||
            payload?.mimeType ||
            payload?.mediaMimeType ||
            ''
        ).toLowerCase()

        const type = String(
            payload?.msgType ||
            payload?.type ||
            payload?.messageType ||
            first?.type ||
            ''
        ).toLowerCase()

        const isImage = mime.startsWith('image/') || type.includes('image')
        if (isImage) return '发来一张图片'

        const isVideo = mime.startsWith('video/') || type.includes('video')
        if (isVideo) return '发来一个视频'

        const isAudio = mime.startsWith('audio/') || type.includes('audio') || type.includes('ptt')
        if (isAudio) return '发来一段语音'

        return '发来一个附件'
    }

    const derived = rawMessage.trim() ? rawMessage : pickDefaultAttachmentText()
    const message = derived && String(derived).trim() ? derived : '收到一条新消息'

    const whatsappSvg = `<svg t="1773673853584" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8723" width="32" height="32"><path d="M512 85.333333a426.666667 426.666667 0 0 0-345.6 676.693334L128 878.933333a20.906667 20.906667 0 0 0 5.12 21.76 21.76 21.76 0 0 0 21.76 5.546667l121.6-39.253333A426.666667 426.666667 0 1 0 512 85.333333z m248.32 602.453334a119.893333 119.893333 0 0 1-85.333333 60.16c-22.186667 4.693333-51.626667 8.533333-149.333334-32a530.346667 530.346667 0 0 1-213.333333-187.733334 242.773333 242.773333 0 0 1-50.773333-128 136.96 136.96 0 0 1 42.666666-104.106666 63.573333 63.573333 0 0 1 42.666667-15.36h14.08c12.373333 0 18.773333 0 27.306667 20.906666s34.986667 85.333333 37.973333 92.16a24.32 24.32 0 0 1 2.133333 23.04 78.933333 78.933333 0 0 1-14.08 19.626667c-5.973333 7.253333-12.373333 12.8-18.346666 20.48a20.053333 20.053333 0 0 0-5.12 26.88 381.44 381.44 0 0 0 69.12 85.333333 313.173333 313.173333 0 0 0 100.266666 61.866667 26.453333 26.453333 0 0 0 29.866667-4.693333 426.666667 426.666667 0 0 0 33.28-42.666667 23.893333 23.893333 0 0 1 30.72-8.96c11.52 3.84 72.533333 34.133333 85.333333 40.106667s20.906667 9.386667 23.893334 14.506666a106.666667 106.666667 0 0 1-2.986667 58.453334z" p-id="8724" fill="#f0f0f0"></path></svg>`
    ElNotification({
        position: 'bottom-right',
        duration: 2500,
        dangerouslyUseHTMLString: true,
        onClick() {
            try {
                const chatIdToOpen = String(payload?.chatId || '')
                if (chatIdToOpen) {
                    window.dispatchEvent(new CustomEvent('wa-open-chat', {
                        detail: {
                            chatId: chatIdToOpen,
                            payload
                        }
                    }))
                }
            } catch (e) {
            }
            if (typeof fun === 'function') fun()
        },
        message: `<div class="notify_box">
            <div class="notify_left">
                <div class="notify_inner" style="background-color:#25D366;padding: 0px 14px;border-radius: 8px">
                    ${whatsappSvg}
                </div>
                <div class="badge">
                    ${messageNumber}
                </div>
            </div>
            <div class="notify_right" style="width: 200px;">
                <div>
                    <span class="notification" style="display:inline-block;width:100%;padding-right:20px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden">
                        ${titleDisplay}
                    </span>
                </div>
                <div style="width: 185px;
                    height: auto;
                    overflow: hidden;
                    box-sizing: border-box;
                    word-wrap: break-word;
                    white-space: normal;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;">
                    ${message}
                </div>
            </div>
        </div>`
    })
    } catch (e) {
        try {
            ElNotification({
                position: 'bottom-right',
                duration: 2500,
                message: '收到一条新消息',
                onClick() {
                    if (typeof fun === 'function') fun()
                }
            })
        } catch (e2) {
        }
    }
}